/* istanbul ignore file */
// TODO: add coverage
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classNames from 'classnames/bind'
import MultipleForm from '../../../base/multipleForm'
import {
  ensureOneOpenedOnClose,
  onlyOneOpenedOnOpen,
  combineReducers,
} from '../../../base/reducers'
import Title from '../../../title'
import { ConfirmationModal } from '@adc/ui-core'
import {
  FORM_NAME,
  FORM_TITLE_FIELDS,
  FORM_TITLE_LABELS,
  INTERESTED_PARTY_FORM_TYPE,
  INTERESTED_PARTY_LABEL,
} from '../constants'
import {
  getBackgroundColor,
  rulesType,
  getTotalOwnershipOfGroup,
} from '../utils'
import IndividualForm from '../individualForm'
import InterestedPartyForm from '../interestedPartyForm'
import SubEntityFormHeader from '../subEntityFormHeader'
import styles from './styles.scss'
const cx = classNames.bind(styles)

const selector = formValueSelector(FORM_NAME)
const PERCENT_100 = 100

class SubEntityForm extends Component {
  static propTypes = {
    formKey: PropTypes.string.isRequired,
    forms: PropTypes.array.isRequired,
    fieldArraysIndex: PropTypes.number,
    onClose: PropTypes.func.isRequired,
    fields: PropTypes.object,
    meta: PropTypes.object,
    entityType: PropTypes.string,
    interestedParties: PropTypes.array,
    dispatch: PropTypes.func,
    isAutoCapitalize: PropTypes.bool,
    isOhioAsset: PropTypes.bool,
    contentOpenedContext: PropTypes.shape({
      contentOpened: PropTypes.object.isRequired,
      deleteKey: PropTypes.func.isRequired,
      updateContentOpened: PropTypes.func.isRequired,
    }).isRequired,
    ...rulesType,
  }

  state = {
    openedFormIndex: 0,
    closeConfirmationModalOpen: false,
    sideTitleContent: '',
  }

  onToggle = () => {
    const { formKey, contentOpenedContext } = this.props
    const { updateContentOpened, contentOpened } = contentOpenedContext
    updateContentOpened(formKey, !contentOpened[formKey], false)
  }

  onClose = () => {
    this.setState({
      closeConfirmationModalOpen: true,
    })
  }

  closeModal = (cb = _.noop) => {
    this.setState(
      {
        closeConfirmationModalOpen: false,
      },
      cb
    )
  }

  onModalClose = () => {
    this.closeModal()
  }

  onModalConfirm = () => {
    this.closeModal(this.props.onClose)
    this.recalculateOpenedFormIndex()
  }

  onSelectItem = (callback, index, type) => {
    if (this.state.openedFormIndex === index) {
      return
    }
    this.setState({ openedFormIndex: index, subTitle: type }, () => {
      this.props.dispatch(
        change(FORM_NAME, `${this.props.formKey}.subFormType`, type)
      )
      callback(index)
    })
  }

  // assured we have at least one index opened
  getFormTypeTitle = openIndices => {
    const { forms } = this.props
    const openedFormTypeIndex = openIndices[0]
    return forms[openedFormTypeIndex]?.label || ''
  }

  getRemoveModalBody = openIndices => {
    const typeTitle = this.getFormTypeTitle(openIndices)
    let body = `Are you sure you want to remove this ${typeTitle}?`
    if (typeTitle === INTERESTED_PARTY_LABEL) {
      body += ' Doing so will remove all interested parties within it.'
    }
    return body
  }

  updateOwnershipInTitle = (allowEmptyInput = false) => {
    const { interestedParties, fieldArraysIndex } = this.props
    const currentLevelValue = interestedParties[fieldArraysIndex] || {}

    let ownership =
      currentLevelValue.subFormType === INTERESTED_PARTY_FORM_TYPE
        ? currentLevelValue.interestedPartyOwnership
        : currentLevelValue.individualOwnership
    if (typeof ownership === 'undefined' && !allowEmptyInput) {
      const totalOwnership = getTotalOwnershipOfGroup(interestedParties)
      ownership =
        totalOwnership < PERCENT_100
          ? PERCENT_100 - getTotalOwnershipOfGroup(interestedParties)
          : 0
      this.props.dispatch(
        change(
          FORM_NAME,
          `${this.props.formKey}.interestedPartyOwnership`,
          ownership
        )
      )
      this.props.dispatch(
        change(
          FORM_NAME,
          `${this.props.formKey}.individualOwnership`,
          ownership
        )
      )
    }

    const ownershipValue = Number(ownership)
    const sideTitleContent = isNaN(ownershipValue)
      ? ''
      : `${ownershipValue.toFixed(2)} %`
    this.setState({
      sideTitleContent,
    })
  }

  recalculateOpenedFormIndex = () => {
    const { interestedParties, fieldArraysIndex, forms } = this.props
    const currentLevelValue = interestedParties[fieldArraysIndex] || {}
    const formType = currentLevelValue.subFormType
      ? currentLevelValue.subFormType
      : INTERESTED_PARTY_FORM_TYPE

    let initialOpenIndex = 0

    initialOpenIndex = forms.findIndex(f => f.formType === formType)

    this.setState({ openedFormIndex: initialOpenIndex })
    this.onSelectItem(_.noop, initialOpenIndex, formType)
    this.updateOwnershipInTitle()
  }

  componentDidMount() {
    const { interestedParties, fieldArraysIndex, forms } = this.props
    const currentLevelValue = interestedParties[fieldArraysIndex] || {}
    const formType = currentLevelValue.subFormType
      ? currentLevelValue.subFormType
      : INTERESTED_PARTY_FORM_TYPE

    let initialOpenIndex = 0

    initialOpenIndex = forms.findIndex(f => f.formType === formType)

    this.setState({ openedFormIndex: initialOpenIndex })
    this.updateOwnershipInTitle()
  }

  componentDidUpdate(prevProps) {
    const { interestedParties, fieldArraysIndex } = this.props
    const currentLevelValue = interestedParties[fieldArraysIndex] || {}
    const ownership =
      currentLevelValue.subFormType === INTERESTED_PARTY_FORM_TYPE
        ? currentLevelValue.interestedPartyOwnership
        : currentLevelValue.individualOwnership
    const {
      interestedParties: oldInterestedParties,
      fieldArraysIndex: oldFieldArraysIndex,
    } = prevProps
    const oldLevelValue = oldInterestedParties[oldFieldArraysIndex] || {}
    const oldOwnership =
      oldLevelValue.subFormType === INTERESTED_PARTY_FORM_TYPE
        ? oldLevelValue.interestedPartyOwnership
        : oldLevelValue.individualOwnership

    if (ownership !== oldOwnership) {
      this.updateOwnershipInTitle(true)
    }

    if (oldInterestedParties.length !== interestedParties.length) {
      this.recalculateOpenedFormIndex()
    }
  }

  render() {
    const {
      forms,
      meta,
      rules,
      fields,
      formKey,
      entityType,
      fieldArraysIndex,
      interestedParties,
      isAutoCapitalize,
      isOhioAsset,
      contentOpenedContext,
    } = this.props

    const contentOpened = Boolean(contentOpenedContext.contentOpened[formKey])
    const backgroundColor = getBackgroundColor(formKey)

    let {
      title,
      subTitle,
      closeConfirmationModalOpen,
      openedFormIndex,
      sideTitleContent,
    } = this.state

    const currentLevelValue = interestedParties[fieldArraysIndex] || {}
    const hasChildren =
      currentLevelValue.subFormType === INTERESTED_PARTY_FORM_TYPE &&
      _.get(currentLevelValue, 'interestedParties', []).length > 0
    const noFormType = !currentLevelValue.subFormType
    const formType = currentLevelValue.subFormType
      ? currentLevelValue.subFormType
      : INTERESTED_PARTY_FORM_TYPE
    title = currentLevelValue[FORM_TITLE_FIELDS[formType]]
    subTitle = FORM_TITLE_LABELS[formType]

    let initialOpenIndices = [0]

    forms.forEach((f, i) => {
      // set the openIndices
      if (f.formType === formType) {
        initialOpenIndices = [i]
      }
    })

    return (
      <MultipleForm
        stateReducer={combineReducers(
          ensureOneOpenedOnClose,
          onlyOneOpenedOnOpen
        )}
        openIndices={initialOpenIndices}
      >
        {({ openIndices, handleItemClick }) => (
          <div
            className={cx(contentOpened && 'u-pb-4')}
            key={fieldArraysIndex}
            style={{ backgroundColor: backgroundColor.prevLevelRGB }}
          >
            <ConfirmationModal
              title={`Confirm ${this.getFormTypeTitle(openIndices)} Deletion`}
              open={closeConfirmationModalOpen}
              onClose={this.onModalClose}
              onConfirm={this.onModalConfirm}
            >
              <span>{this.getRemoveModalBody(openIndices)}</span>
            </ConfirmationModal>
            <Title
              mainContent={title}
              subContent={subTitle}
              sideContent={sideTitleContent}
              onClose={this.onClose}
              onToggle={this.onToggle}
              opened={contentOpened}
              elmId={formKey}
            />
            <div
              className={cx('content-body', {
                'title-only': !contentOpened,
              })}
              style={{
                backgroundColor:
                  (!contentOpened && !hasChildren) || noFormType
                    ? backgroundColor.prevLevelRGB
                    : backgroundColor.currentRGB,
              }}
            >
              {contentOpened && (
                <div className={cx('form-options')}>
                  <SubEntityFormHeader
                    formKey={formKey}
                    forms={forms}
                    handleItemClick={handleItemClick}
                    onSelectItem={this.onSelectItem}
                    openedFormIndex={openedFormIndex}
                  />
                </div>
              )}
              <div key={initialOpenIndices[0]}>
                <div className={contentOpened ? cx('opened') : cx('closed')}>
                  {formType === INTERESTED_PARTY_FORM_TYPE ? (
                    <InterestedPartyForm
                      key={initialOpenIndices[0]}
                      formKey={formKey}
                      fields={fields}
                      meta={meta}
                      rules={rules}
                      interestedParties={interestedParties}
                      entityType={entityType}
                      fieldArraysIndex={fieldArraysIndex}
                      showTitlesOnly={!contentOpened}
                      backgroundColor={backgroundColor}
                      isAutoCapitalize={isAutoCapitalize}
                      isOhioAsset={isOhioAsset}
                      contentOpenedContext={contentOpenedContext}
                    />
                  ) : (
                    <IndividualForm
                      key={initialOpenIndices[0]}
                      formKey={formKey}
                      fields={fields}
                      meta={meta}
                      rules={rules}
                      interestedParties={interestedParties}
                      entityType={entityType}
                      fieldArraysIndex={fieldArraysIndex}
                      showTitlesOnly={!contentOpened}
                      backgroundColor={backgroundColor}
                      isAutoCapitalize={isAutoCapitalize}
                      isOhioAsset={isOhioAsset}
                      contentOpenedContext={contentOpenedContext}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </MultipleForm>
    )
  }
}

export default connect((state, props) => {
  return {
    fieldValues: selector(state, props.formKey),
  }
})(SubEntityForm)
